"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/edit/24.js"));
var _2 = _interopRequireDefault(require("@carbon/icons-react/lib/trash-can/24.js"));
var _3 = _interopRequireDefault(require("@carbon/icons-react/lib/change-catalog/24.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.table {\n  margin-bottom: 3rem; }\n  .table .bx--data-table-content {\n    border: 1px solid #e8e8e8; }\n    .table .bx--data-table-content thead {\n      background: #e8e8e8; }\n      .table .bx--data-table-content thead th {\n        background: transparent; }\n        .table .bx--data-table-content thead th .bx--table-header-label {\n          margin-right: 24px;\n          color: #e41b13;\n          white-space: nowrap; }\n        .table .bx--data-table-content thead th.right .bx--table-sort__flex {\n          justify-content: end; }\n          .table .bx--data-table-content thead th.right .bx--table-sort__flex .bx--table-header-label {\n            margin-right: 0;\n            margin-left: 24px; }\n        .table .bx--data-table-content thead th.right .bx--table-header-label {\n          text-align: right;\n          margin-right: 0;\n          margin-left: 24px; }\n        .table .bx--data-table-content thead th button.bx--table-sort {\n          background: transparent; }\n          .table .bx--data-table-content thead th button.bx--table-sort .bx--table-sort__icon-unsorted {\n            opacity: 1; }\n          .table .bx--data-table-content thead th button.bx--table-sort .bx--table-sort__icon {\n            filter: invert(17%) sepia(55%) saturate(5926%) hue-rotate(354deg) brightness(94%) contrast(96%); }\n    .table .bx--data-table-content tbody {\n      background: transparent; }\n      .table .bx--data-table-content tbody tr:hover {\n        background: transparent; }\n        .table .bx--data-table-content tbody tr:hover td {\n          background: transparent;\n          border-top: 1px solid #e8e8e8;\n          border-bottom: none; }\n      .table .bx--data-table-content tbody tr td {\n        background: transparent;\n        color: #4c4c4c;\n        border-top: 1px solid #e8e8e8;\n        border-bottom: none;\n        padding-top: 1rem;\n        padding-bottom: 1rem;\n        line-height: 20px; }\n        .table .bx--data-table-content tbody tr td.right {\n          text-align: right; }\n        .table .bx--data-table-content tbody tr td .actions {\n          display: flex; }\n          .table .bx--data-table-content tbody tr td .actions svg {\n            margin-left: 20px;\n            float: left; }\n            .table .bx--data-table-content tbody tr td .actions svg:first-child {\n              margin-left: 0; }\n            .table .bx--data-table-content tbody tr td .actions svg:hover {\n              cursor: pointer; }\n            .table .bx--data-table-content tbody tr td .actions svg.change {\n              margin-top: 1px; }\n    .table .bx--data-table-content tbody tr:last-child .actions {\n      border-bottom: 0; }\n\n@media (max-width: 42rem) {\n  .table {\n    margin-bottom: 3rem; }\n    .table tbody {\n      background: transparent; }\n      .table tbody tr td .actions {\n        float: right;\n        margin-right: 16px; } }\n";
  const fileName = "Table_Table";
  const element = document.querySelector("style[data-sass-component='Table_Table']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Table = props => {
  const ref = (0, _react.useRef)(null);
  const resizeColumns = () => {
    const table = ref.current;
    props.columns.forEach((column, index) => {
      const sequence = index + 1;
      const isLast = sequence === props.columns.length;
      const headerCell = table.querySelector(`th:nth-child(${sequence})`);
      /**
       * Using absolute width, was not able to minimize width of th with relative width.
       * Using document's element.style because <TableHeader>'s style prop only applies to its <button>.
       */
      if (column.alignment?.maximum) {
        headerCell.style.width = column.alignment.maximum + 'px';
        return;
      }
      if (!isLast) {
        headerCell.style.width = '1px'; // to squeeze as small as possible. could not do with outside CSS.
      }
    });
  };
  (0, _react.useEffect)(() => {
    resizeColumns();
  }, []);
  const createCarbonColumnsFromColumns = columns => columns.map(column => {
    return {
      key: column.name,
      header: column.label,
      class: column.class,
      sortable: column.sortable
    };
  });
  const carbonColumns = createCarbonColumnsFromColumns(props.columns);
  const sortable = !props.hasOwnProperty('sortable') ? true : props.sortable;
  const hasActions = Boolean(props.actions && props.actions.length);
  const renderActionIcon = (action, id) => {
    if (action.custom) {
      return action.custom();
    }
    const minimumProps = {
      className: action.name,
      onClick: () => action.onClick(id),
      key: `${id}-${action.name}`
    };
    switch (action.name) {
      case 'change':
        return /*#__PURE__*/_react.default.createElement(_.default, minimumProps);
      case 'remove':
        return /*#__PURE__*/_react.default.createElement(_2.default, minimumProps);
      case 'mutate':
        return /*#__PURE__*/_react.default.createElement(_3.default, minimumProps);
      default:
        return null;
    }
  };
  const createCellClasses = column => {
    const classes = [];
    if (column.class) {
      classes.push(column.class);
    }
    if (column.alignment?.right) {
      classes.push('right');
    }
    return classes;
  };
  const createActionsWidth = () => {
    const iconWidth = 24;
    const cellPaddings = 2 * 16;
    const iconMargins = (props.actions.length - 1) * 20;
    const width = props.actions.length * iconWidth + cellPaddings + iconMargins;
    return `${width}px`;
  };
  const renderCarbonTable = (carbonColumns, items) => {
    return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.DataTable, {
      rows: items,
      headers: carbonColumns,
      isSortable: sortable
    }, _ref => {
      let {
        rows,
        headers,
        getHeaderProps,
        getRowProps,
        getTableProps
      } = _ref;
      return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Table, getTableProps(), /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableHead, null, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableRow, null, headers.map(header => {
        const isSortable = () => header.sortable === false ? false : sortable;
        const currentColumnName = header.key;
        const column = props.columns.find(column => column.name === currentColumnName);
        const classes = createCellClasses(column);
        return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableHeader, _extends({
          key: header.key
        }, getHeaderProps({
          header
        }), {
          className: classes.join(' '),
          isSortable: isSortable()
        }), header.header);
      }), (hasActions || props.addExtraColumn) && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableHeader, {
        isSortable: false,
        style: {
          width: createActionsWidth()
        }
      }))), /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableBody, null, rows.map(row => {
        const rowAction = props.getRowAction ? props.getRowAction(row) : null;
        return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableRow, _extends({
          key: row.id
        }, getRowProps({
          row
        }), {
          className: props.getRowClassName ? props.getRowClassName(row) : null
        }), row.cells.map(cell => {
          const rawValue = cell.value;
          const currentColumnName = cell.info.header;
          const item = items.find(item => item.id === row.id);
          const column = props.columns.find(column => column.name === currentColumnName);
          const value = column.format ? column.format(rawValue, item) : rawValue;
          const classes = createCellClasses(column);
          return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableCell, {
            key: cell.id,
            className: classes.join(' ')
          }, value);
        }), hasActions && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableCell, null, /*#__PURE__*/_react.default.createElement("div", {
          className: 'actions'
        }, props.actions.map(action => renderActionIcon(action, row.id)))), rowAction && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableCell, null, /*#__PURE__*/_react.default.createElement("div", {
          className: 'actions'
        }, renderActionIcon(rowAction, row.id))));
      })));
    });
  };
  const classNames = ['table', props.className ? props.className : null];
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: classNames.join(' ')
  }, renderCarbonTable(carbonColumns, props.items));
};
Table.propTypes = {
  columns: _propTypes.default.array.isRequired,
  items: _propTypes.default.array.isRequired,
  sortable: _propTypes.default.bool,
  className: _propTypes.default.string,
  getRowClassName: _propTypes.default.func,
  getRowAction: _propTypes.default.func,
  addExtraColumn: _propTypes.default.bool
};
var _default = exports.default = Table;